import { render, staticRenderFns } from "./NewContactModal.vue?vue&type=template&id=ad5d7082&scoped=true"
import script from "./NewContactModal.vue?vue&type=script&lang=ts"
export * from "./NewContactModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5d7082",
  null
  
)

export default component.exports